import { createReducer, on } from '@ngrx/store';
import { ResourceStatuses, createRequestError } from '@platform/shared/resource.state';

import * as CoreActions from './core.actions';
import { initialCoreState } from './core.state';

export const coreReducer = createReducer(
  initialCoreState,
  on(CoreActions.loadCustomerSpace, (state) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      navigated: {
        ...state.customerSpace.navigated,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.loadCustomerSpaceSucceeded, (state, { customerSpace }) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      navigated: {
        ...state.customerSpace.navigated,
        status: ResourceStatuses.SUCCEEDED,
        data: { ...customerSpace },
        error: null!,
      },
    },
  })),

  on(CoreActions.loadCustomerSpaceFailed, (state, { status, errors }) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      navigated: {
        ...state.customerSpace.navigated,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.loadCustomerSpaces, (state) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      all: {
        ...state.customerSpace.all,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.loadCustomerSpacesSucceeded, (state, { customerSpaces }) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      all: {
        ...state.customerSpace.all,
        status: ResourceStatuses.SUCCEEDED,
        data: [...customerSpaces],
        error: null!,
      },
      count: customerSpaces.length,
    },
  })),

  on(CoreActions.loadCustomerSpacesFailed, (state, { status, errors }) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      all: {
        ...state.customerSpace.all,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.loadCustomerSpaceCountSucceeded, (state, { count }) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      count,
    },
  })),

  on(CoreActions.resetCustomerSpaceAdmin, (state) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      admin: {
        ...state.customerSpace.admin,
        data: null!,
        status: ResourceStatuses.NONE,
      },
    },
  })),

  on(CoreActions.loadCustomerSpaceAdmin, (state) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      admin: {
        ...state.customerSpace.admin,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.loadCustomerSpaceAdminSucceeded, (state, { customerSpace }) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      admin: {
        ...state.customerSpace.admin,
        status: ResourceStatuses.SUCCEEDED,
        data: { ...customerSpace },
        error: null!,
      },
    },
  })),

  on(CoreActions.loadCustomerSpaceAdminFailed, (state, { status, errors }) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      admin: {
        ...state.customerSpace.admin,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.deleteCustomerSpace, (state) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      admin: {
        ...state.customerSpace.admin,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.deleteCustomerSpaceSucceeded, (state, {}) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      admin: {
        ...state.customerSpace.admin,
        status: ResourceStatuses.NONE,
        data: null!,
        error: null!,
      },
    },
  })),

  on(CoreActions.deleteCustomerSpaceFailed, (state, { status, errors }) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      admin: {
        ...state.customerSpace.admin,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.removeCustomerSpaceUser, (state) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      admin: {
        ...state.customerSpace.admin,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.removeCustomerSpaceUserSucceeded, (state, { customerSpace }) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      admin: {
        ...state.customerSpace.admin,
        status: ResourceStatuses.SUCCEEDED,
        data: { ...customerSpace },
        error: null!,
      },
    },
  })),

  on(CoreActions.removeCustomerSpaceUserFailed, (state, { status, errors }) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      admin: {
        ...state.customerSpace.admin,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.updateCustomerSpaceUser, (state) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      admin: {
        ...state.customerSpace.admin,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.updateCustomerSpaceUserSucceeded, (state, { customerSpace }) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      admin: {
        ...state.customerSpace.admin,
        status: ResourceStatuses.SUCCEEDED,
        data: { ...customerSpace },
        error: null!,
      },
    },
  })),

  on(CoreActions.updateCustomerSpaceUserFailed, (state, { status, errors }) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      admin: {
        ...state.customerSpace.admin,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.createCustomerSpace, (state) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      admin: {
        ...state.customerSpace.admin,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.createCustomerSpaceSucceeded, (state, { customerSpace }) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      admin: {
        ...state.customerSpace.admin,
        status: ResourceStatuses.SUCCEEDED,
        data: { ...customerSpace },
        error: null!,
      },
    },
  })),

  on(CoreActions.createCustomerSpaceFailed, (state, { status, errors }) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      admin: {
        ...state.customerSpace.admin,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.updateCustomerSpace, (state) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      admin: {
        ...state.customerSpace.admin,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.updateCustomerSpaceSucceeded2, (state, { customerSpace }) => {
    // if we modified the customer space that was in the navigated state
    // we need to also update the navigated object because this is not reloaded from backend
    if (state.customerSpace.navigated?.data?.id === customerSpace.id) {
      return {
        ...state,
        customerSpace: {
          ...state.customerSpace,
          navigated: {
            ...state.customerSpace.admin,
            status: ResourceStatuses.SUCCEEDED,
            data: { ...customerSpace, notificationCount: 0, openTaskCount: 0, isFavorite: state.customerSpace.navigated.data.isFavorite },
            error: null!,
          },
          admin: {
            ...state.customerSpace.admin,
            status: ResourceStatuses.SUCCEEDED,
            data: { ...customerSpace },
            error: null!,
          },
        },
      };
    } else {
      return {
        ...state,
        customerSpace: {
          ...state.customerSpace,
          admin: {
            ...state.customerSpace.admin,
            status: ResourceStatuses.SUCCEEDED,
            data: { ...customerSpace },
            error: null!,
          },
        },
      };
    }
  }),

  on(CoreActions.updateCustomerSpaceSucceeded, (state, { customerSpace }) => {
    // if we modified the customer space that was in the navigated state
    // we need to also update the navigated object because this is not reloaded from backend
    if (state.customerSpace.navigated?.data?.id === customerSpace.id) {
      return {
        ...state,
        customerSpace: {
          ...state.customerSpace,
          navigated: {
            ...state.customerSpace.admin,
            status: ResourceStatuses.SUCCEEDED,
            data: { ...customerSpace, notificationCount: 0, openTaskCount: 0, isFavorite: state.customerSpace.navigated.data.isFavorite },
            error: null!,
          },
          admin: {
            ...state.customerSpace.admin,
            status: ResourceStatuses.SUCCEEDED,
            data: { ...customerSpace },
            error: null!,
          },
        },
      };
    } else {
      return {
        ...state,
        customerSpace: {
          ...state.customerSpace,
          admin: {
            ...state.customerSpace.admin,
            status: ResourceStatuses.SUCCEEDED,
            data: { ...customerSpace },
            error: null!,
          },
        },
      };
    }
  }),

  on(CoreActions.updateCustomerSpaceFailed, (state, { status, errors }) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      admin: {
        ...state.customerSpace.admin,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.loadCustomerSpaceUsers, (state) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      users: {
        ...state.customerSpace.users,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.loadCustomerSpaceUsersSucceeded, (state, { users }) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      users: {
        ...state.customerSpace.users,
        status: ResourceStatuses.SUCCEEDED,
        data: users,
        error: null!,
      },
    },
  })),

  on(CoreActions.loadCustomerSpaceUsersFailed, (state, { status, errors }) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      users: {
        ...state.customerSpace.users,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.loadActiveUsers, (state) => ({
    ...state,
    user: {
      ...state.user,
      activeUsers: {
        ...state.user.activeUsers,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.loadActiveUsersSucceeded, (state, { users }) => ({
    ...state,
    user: {
      ...state.user,
      activeUsers: {
        ...state.user.activeUsers,
        status: ResourceStatuses.SUCCEEDED,
        data: users,
        error: null!,
      },
    },
  })),

  on(CoreActions.loadActiveUsersFailed, (state, { status, errors }) => ({
    ...state,
    user: {
      ...state.user,
      activeUsers: {
        ...state.user.activeUsers,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.loadUserOverview, (state) => ({
    ...state,
    user: {
      ...state.user,
      userOverview: {
        ...state.user.userOverview,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.loadUserOverviewSucceeded, (state, { users }) => ({
    ...state,
    user: {
      ...state.user,
      userOverview: {
        ...state.user.userOverview,
        status: ResourceStatuses.SUCCEEDED,
        data: users,
        error: null!,
      },
    },
  })),

  on(CoreActions.loadUserOverviewFailed, (state, { status, errors }) => ({
    ...state,
    user: {
      ...state.user,
      userOverview: {
        ...state.user.userOverview,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.loadUserOrganizationUnits, (state) => ({
    ...state,
    user: {
      ...state.user,
      organizationUnits: {
        ...state.user.organizationUnits,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.loadUserOrganizationUnitsSucceeded, (state, { organizationUnits }) => ({
    ...state,
    user: {
      ...state.user,
      organizationUnits: {
        ...state.user.organizationUnits,
        status: ResourceStatuses.SUCCEEDED,
        data: organizationUnits,
        error: null!,
      },
    },
  })),

  on(CoreActions.loadUserOrganizationUnitsFailed, (state, { status, errors }) => ({
    ...state,
    user: {
      ...state.user,
      organizationUnits: {
        ...state.user.organizationUnits,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.createUser, (state) => ({
    ...state,
    user: {
      ...state.user,
      created: {
        ...state.user.created,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.createUserSucceeded, (state, { user }) => ({
    ...state,
    user: {
      ...state.user,
      created: {
        ...state.user.created,
        status: ResourceStatuses.SUCCEEDED,
        data: user,
        error: null!,
      },
    },
  })),

  on(CoreActions.createUserFailed, (state, { status, errors }) => ({
    ...state,
    user: {
      ...state.user,
      created: {
        ...state.user.created,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.clearCreatedUser, (state) => ({
    ...state,
    user: {
      ...state.user,
      created: {
        ...state.user.created,
        status: ResourceStatuses.NONE,
        error: null!,
        data: null!,
      },
    },
  })),

  on(CoreActions.loadUserProfile, (state) => ({
    ...state,
    user: {
      ...state.user,
      profile: {
        ...state.user.profile,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.loadUserProfileSucceeded, (state, { userProfile }) => ({
    ...state,
    user: {
      ...state.user,
      profile: {
        ...state.user.profile,
        status: ResourceStatuses.SUCCEEDED,
        data: userProfile,
        error: null!,
      },
    },
  })),

  on(CoreActions.loadUserProfileFailed, (state, { status, errors }) => ({
    ...state,
    user: {
      ...state.user,
      profile: {
        ...state.user.profile,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.updateUserProfile, (state) => ({
    ...state,
    user: {
      ...state.user,
      profile: {
        ...state.user.profile,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.updateUserProfileSucceeded, (state, { userProfile }) => ({
    ...state,
    user: {
      ...state.user,
      profile: {
        ...state.user.profile,
        status: ResourceStatuses.SUCCEEDED,
        data: userProfile,
        error: null!,
      },
    },
  })),

  on(CoreActions.updateUserProfileFailed, (state, { status, errors }) => ({
    ...state,
    user: {
      ...state.user,
      profile: {
        ...state.user.profile,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.addUserDeputy, (state) => ({
    ...state,
    user: {
      ...state.user,
      profile: {
        ...state.user.profile,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.addUserDeputySucceeded, (state, { userProfile }) => ({
    ...state,
    user: {
      ...state.user,
      profile: {
        ...state.user.profile,
        status: ResourceStatuses.SUCCEEDED,
        data: userProfile,
        error: null!,
      },
    },
  })),

  on(CoreActions.addUserDeputyFailed, (state, { status, errors }) => ({
    ...state,
    user: {
      ...state.user,
      profile: {
        ...state.user.profile,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.removeUserDeputy, (state) => ({
    ...state,
    user: {
      ...state.user,
      profile: {
        ...state.user.profile,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.removeUserDeputySucceeded, (state, { userProfile }) => ({
    ...state,
    user: {
      ...state.user,
      profile: {
        ...state.user.profile,
        status: ResourceStatuses.SUCCEEDED,
        data: userProfile,
        error: null!,
      },
    },
  })),

  on(CoreActions.removeUserDeputyFailed, (state, { status, errors }) => ({
    ...state,
    user: {
      ...state.user,
      profile: {
        ...state.user.profile,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.resendWelcomeMail, (state) => ({
    ...state,
    user: {
      ...state.user,
      profile: {
        ...state.user.profile,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.resendWelcomeMailSucceeded, (state, { userProfile }) => ({
    ...state,
    user: {
      ...state.user,
      profile: {
        ...state.user.profile,
        status: ResourceStatuses.SUCCEEDED,
        data: userProfile,
        error: null!,
      },
    },
  })),

  on(CoreActions.resendWelcomeMailFailed, (state, { status, errors }) => ({
    ...state,
    user: {
      ...state.user,
      profile: {
        ...state.user.profile,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.extractSharepointCustomerSpaceTemplate, (state) => ({
    ...state,
    admin: {
      ...state.admin,
      sharepointTemplateExtraction: {
        ...state.admin.sharepointTemplateExtraction,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.extractSharepointCustomerSpaceTemplateSucceeded, (state) => ({
    ...state,
    admin: {
      ...state.admin,
      sharepointTemplateExtraction: {
        ...state.admin.sharepointTemplateExtraction,
        status: ResourceStatuses.SUCCEEDED,
        error: null!,
      },
      templateActualisation: {
        ...state.admin.templateActualisation,
        data: {
          ...state.admin.templateActualisation.data,
          latestCustomerSpaceTemplateActualisation: new Date(),
        },
      },
    },
  })),

  on(CoreActions.extractSharepointCustomerSpaceTemplateFailed, (state, { status, errors }) => ({
    ...state,
    admin: {
      ...state.admin,
      sharepointTemplateExtraction: {
        ...state.admin.sharepointTemplateExtraction,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.extractSharepointProjectTemplate, (state) => ({
    ...state,
    admin: {
      ...state.admin,
      sharepointTemplateExtraction: {
        ...state.admin.sharepointTemplateExtraction,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.extractSharepointProjectTemplateSucceeded, (state) => ({
    ...state,
    admin: {
      ...state.admin,
      sharepointTemplateExtraction: {
        ...state.admin.sharepointTemplateExtraction,
        status: ResourceStatuses.SUCCEEDED,
        error: null!,
      },
      templateActualisation: {
        ...state.admin.templateActualisation,
        data: {
          ...state.admin.templateActualisation.data,
          latestProjectTemplateActualisation: new Date(),
        },
      },
    },
  })),

  on(CoreActions.extractSharepointProjectTemplateFailed, (state, { status, errors }) => ({
    ...state,
    admin: {
      ...state.admin,
      sharepointTemplateExtraction: {
        ...state.admin.sharepointTemplateExtraction,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.getLatestTemplateActualisations, (state) => ({
    ...state,
    admin: {
      ...state.admin,
      templateActualisation: {
        ...state.admin.templateActualisation,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.getLatestTemplateActualisationsSucceeded, (state, { templateActualisation }) => ({
    ...state,
    admin: {
      ...state.admin,
      templateActualisation: {
        ...state.admin.templateActualisation,
        status: ResourceStatuses.SUCCEEDED,
        error: null!,
        data: templateActualisation,
      },
    },
  })),

  on(CoreActions.getLatestTemplateActualisationsFailed, (state, { status, errors }) => ({
    ...state,
    admin: {
      ...state.admin,
      templateActualisation: {
        ...state.admin.templateActualisation,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.loadContacts, (state) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      contacts: {
        ...state.customerSpace.contacts,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.loadContactsSucceeded, (state, { contacts }) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      contacts: {
        ...state.customerSpace.contacts,
        status: ResourceStatuses.SUCCEEDED,
        data: contacts,
        error: null!,
      },
    },
  })),

  on(CoreActions.loadContactsFailed, (state, { status, errors }) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      contacts: {
        ...state.customerSpace.contacts,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.getCustomerSpaceNotifications, (state) => ({
    ...state,
    notification: {
      ...state.notification,
      customerSpace: {
        ...state.notification.customerSpace,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.getCustomerSpaceNotificationsSucceeded, (state, { notifications }) => ({
    ...state,
    notification: {
      ...state.notification,
      customerSpace: {
        ...state.notification.customerSpace,
        status: ResourceStatuses.SUCCEEDED,
        data: notifications,
        error: null!,
      },
    },
  })),

  on(CoreActions.getCustomerSpaceNotificationsFailed, (state, { status, errors }) => ({
    ...state,
    notification: {
      ...state.notification,
      customerSpace: {
        ...state.notification.customerSpace,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.markNotificationAsRead, (state) => ({
    ...state,
    notification: {
      ...state.notification,
      customerSpace: {
        ...state.notification.customerSpace,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.markNotificationAsReadSucceeded, (state, { notifications }) => ({
    ...state,
    notification: {
      ...state.notification,
      customerSpace: {
        ...state.notification.customerSpace,
        status: ResourceStatuses.SUCCEEDED,
        data: notifications,
        error: null!,
      },
    },
  })),

  on(CoreActions.markNotificationAsReadFailed, (state, { status, errors }) => ({
    ...state,
    notification: {
      ...state.notification,
      customerSpace: {
        ...state.notification.customerSpace,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.markNotificationAsUnread, (state) => ({
    ...state,
    notification: {
      ...state.notification,
      customerSpace: {
        ...state.notification.customerSpace,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.markNotificationAsUnreadSucceeded, (state, { notifications }) => ({
    ...state,
    notification: {
      ...state.notification,
      customerSpace: {
        ...state.notification.customerSpace,
        status: ResourceStatuses.SUCCEEDED,
        data: notifications,
        error: null!,
      },
    },
  })),

  on(CoreActions.markNotificationAsUnreadFailed, (state, { status, errors }) => ({
    ...state,
    notification: {
      ...state.notification,
      customerSpace: {
        ...state.notification.customerSpace,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.markAllNotificationsAsRead, (state) => ({
    ...state,
    notification: {
      ...state.notification,
      customerSpace: {
        ...state.notification.customerSpace,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.markAllNotificationsAsReadSucceeded, (state, { notifications }) => ({
    ...state,
    notification: {
      ...state.notification,
      customerSpace: {
        ...state.notification.customerSpace,
        status: ResourceStatuses.SUCCEEDED,
        data: notifications,
        error: null!,
      },
    },
  })),

  on(CoreActions.markAllNotificationsAsReadFailed, (state, { status, errors }) => ({
    ...state,
    notification: {
      ...state.notification,
      customerSpace: {
        ...state.notification.customerSpace,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.showNotifications, (state, { show }) => ({
    ...state,
    notification: {
      ...state.notification,
      isShowingNotifications: show,
    },
  })),

  on(CoreActions.loadCurrentUserRepresenteeIds, (state) => ({
    ...state,
    user: {
      ...state.user,
      currentUserRepresenteeIds: {
        ...state.user.currentUserRepresenteeIds,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.loadCurrentUserRepresenteeIdsSucceeded, (state, { representeeIds }) => ({
    ...state,
    user: {
      ...state.user,
      currentUserRepresenteeIds: {
        ...state.user.currentUserRepresenteeIds,
        status: ResourceStatuses.SUCCEEDED,
        data: representeeIds,
        error: null!,
      },
    },
  })),

  on(CoreActions.markAllNotificationsAsReadFailed, (state, { status, errors }) => ({
    ...state,
    user: {
      ...state.user,
      currentUserRepresenteeIds: {
        ...state.user.currentUserRepresenteeIds,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.loadMobileUpload, (state) => ({
    ...state,
    mobileUpload: {
      ...state.mobileUpload,
      loading: {
        ...state.mobileUpload.loading,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.loadMobileUploadSucceeded, (state, { mobileUploadDto }) => ({
    ...state,
    mobileUpload: {
      ...state.mobileUpload,
      loading: {
        ...state.mobileUpload.loading,
        status: ResourceStatuses.SUCCEEDED,
        data: mobileUploadDto,
        error: null!,
      },
    },
  })),

  on(CoreActions.loadMobileUploadFailed, (state, { status, errors }) => ({
    ...state,
    mobileUpload: {
      ...state.mobileUpload,
      loading: {
        ...state.mobileUpload.loading,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.uploadMobileFiles, (state) => ({
    ...state,
    mobileUpload: {
      ...state.mobileUpload,
      upload: {
        ...state.mobileUpload.upload,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.uploadMobileFilesSucceeded, (state) => ({
    ...state,
    mobileUpload: {
      ...state.mobileUpload,
      upload: {
        ...state.mobileUpload.upload,
        status: ResourceStatuses.SUCCEEDED,
        data: null,
        error: null!,
      },
    },
  })),

  on(CoreActions.uploadMobileFilesFailed, (state, { status, errors }) => ({
    ...state,
    mobileUpload: {
      ...state.mobileUpload,
      upload: {
        ...state.mobileUpload.upload,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),

  on(CoreActions.addCustomerSpaceFavoriteSucceeded, (state, { customerSpaceId }) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      all: {
        ...state.customerSpace.all,
        data: state.customerSpace.all.data.map((customerSpace) =>
          customerSpace.id === customerSpaceId ? { ...customerSpace, isFavorite: true } : customerSpace,
        ),
      },
    },
  })),

  on(CoreActions.deleteCustomerSpaceFavoriteSucceeded, (state, { customerSpaceId }) => ({
    ...state,
    customerSpace: {
      ...state.customerSpace,
      all: {
        ...state.customerSpace.all,
        data: state.customerSpace.all.data.map((customerSpace) =>
          customerSpace.id === customerSpaceId ? { ...customerSpace, isFavorite: false } : customerSpace,
        ),
      },
    },
  })),

  on(CoreActions.uploadBatchCreationFile, (state) => ({
    ...state,
    admin: {
      ...state.admin,
      batchCreation: {
        ...state.admin.batchCreation,
        status: ResourceStatuses.PENDING,
      },
    },
  })),

  on(CoreActions.uploadBatchCreationFileSucceeded, (state) => ({
    ...state,
    admin: {
      ...state.admin,
      upload: {
        ...state.admin.batchCreation,
        status: ResourceStatuses.SUCCEEDED,
        data: null,
        error: null!,
      },
    },
  })),

  on(CoreActions.uploadBatchCreationFileFailed, (state, { status, errors }) => ({
    ...state,
    admin: {
      ...state.admin,
      upload: {
        ...state.admin.batchCreation,
        status: ResourceStatuses.FAILED,
        error: createRequestError(status, errors),
      },
    },
  })),
);
